/* Reference image drift, with a persistent user pause and editor-safe lifecycle. */
(() => {
  if (customElements.get('atease-hero-motion')) return;
  customElements.define('atease-hero-motion', class extends HTMLElement {
    connectedCallback() {
      this.button = this.querySelector('button');
      if (!this.button) return;
      this.mobile = matchMedia('(max-width: 767px)');
      this.reduced = matchMedia('(prefers-reduced-motion: reduce)');
      this.inView = true;
      this.update = () => {
        const eligible = this.dataset.enabled !== 'false' && !this.mobile.matches && !this.reduced.matches;
        this.toggleAttribute('data-motion-ready', eligible);
        this.toggleAttribute('data-running', eligible && !this.userPaused && this.inView && !document.hidden);
        this.button.hidden = !eligible;
        this.button.setAttribute('aria-pressed', String(!!this.userPaused));
        this.button.querySelector('[data-motion-icon]').textContent = this.userPaused ? '▶' : 'Ⅱ';
        this.button.querySelector('[data-motion-label]').textContent = this.userPaused ? this.button.dataset.playLabel : this.button.dataset.pauseLabel;
      };
      this.onClick = () => { this.userPaused = !this.userPaused; this.update(); };
      this.button.addEventListener('click', this.onClick);
      this.mobile.addEventListener('change', this.update);
      this.reduced.addEventListener('change', this.update);
      document.addEventListener('visibilitychange', this.update);
      if ('IntersectionObserver' in window) {
        this.observer = new IntersectionObserver(entries => {
          this.inView = entries[0].isIntersecting;
          this.update();
        });
        this.observer.observe(this);
      }
      this.update();
      const hero = this.closest('[data-atease-d2-hero]');
      if (this.hasAttribute('data-running') && hero) hero.setAttribute('data-motion-entry', '');
    }
    disconnectedCallback() {
      this.observer?.disconnect();
      this.button?.removeEventListener('click', this.onClick);
      this.mobile?.removeEventListener('change', this.update);
      this.reduced?.removeEventListener('change', this.update);
      document.removeEventListener('visibilitychange', this.update);
      this.removeAttribute('data-running');
    }
  });
})();
